import { getBackgroundCSS, getColorsCSS } from '../../../../Components/utils/getCSS';

const Style = ({ attributes, clientId }) => {
	const { layout = {}, navBGColor, titleColor, remainingTimeColor, stepsBG, menu = {}, buttons = {} } = attributes;
	const { height } = layout;
	const { themeColor = '#1a73e8', textColor = '#212121' } = menu;
	const { back = { content: 'text', text: 'Back', colors: { color: '#1a73e8', bg: '#fff' } }, next = { content: 'text', text: 'Next', colors: { color: '#fff', bg: '#1a73e8' } }, done = { text: 'Done', linkTab: '_self', colors: { color: '#fff', bg: '#1e8e3e' } } } = buttons;

	const mainSl = `#stpContent-${clientId}`;
	const navSl = `${mainSl} .stpNav`;
	const menuSl = `${mainSl} .stpMenu`;
	const menuLiSl = `${menuSl} ol li`;
	const numberCountLiSl = `${menuSl} .numberCount li`;
	const listRangeLiSl = `${menuSl} .listRange li`;
	const controlsSl = `${mainSl} .stpStepsWrapper .sptStepsControls`;

	return <style dangerouslySetInnerHTML={{
		__html: `
		${mainSl}{
			margin-top: 0;
			margin-bottom: 0;
		}
		${mainSl} .stpContent{
			height: ${height};
		}
		${navSl}{
			background: ${navBGColor};
		}
		${navSl} h2{
			color: ${titleColor};
		}
		${navSl} .remainingTime{
			color: ${remainingTimeColor};
		}
		${mainSl} .stpSection{
			${getBackgroundCSS(stepsBG)};
		}
		${menuSl}{
			width: 295px;
		}
		${menuLiSl} a{
			color: ${textColor.slice(0, 7)}aa;
		}
		${menuLiSl}.complete a, ${menuLiSl}.running a{
			color: ${textColor};
		}
		${numberCountLiSl}.complete a span::before, ${numberCountLiSl}.running a span::before{
			background-color: ${themeColor};
		}
		${listRangeLiSl} a::before {
			background: ${themeColor};
		}
		${listRangeLiSl} a::after {
			border: 3px solid ${themeColor};
		}
		${listRangeLiSl}:first-child a::before {
			background: linear-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 20px, ${themeColor} 21px, ${themeColor});
		}
		${listRangeLiSl}:last-child a::before {
			background: linear-gradient(${themeColor} 0, ${themeColor} 20px, rgba(0, 0, 0, 0) 21px, rgba(0, 0, 0, 0));
		}
		${listRangeLiSl}.running a::after {
			background: radial-gradient(circle, ${themeColor} 0, ${themeColor} 2px, #f5f5f5 3px, #f5f5f5);
		}
		${listRangeLiSl}.complete a::after {
			background: ${themeColor};
		}

		${controlsSl} .prevBtn{
			${getColorsCSS(back.colors)}
		}
		${controlsSl} .nextBtn{
			${getColorsCSS(next.colors)}
		}
		${controlsSl} .doneBtn{
			${getColorsCSS(done.colors)}
		}
		`.replace(/\s+/g, ' ')
	}} />;
}
export default Style;